import axios from 'axios';
import * as Sentry from "@sentry/vue";

export default {
    getCurrentSeason() {
        const options = {
            method: 'get',
            url: `/umbraco/api/ConsolidatedView/GetPeriodTotals`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getFarms(season, showAll = false) {

        const options = {
            method: 'get',
            url: `/umbraco/api/HSFarms/GetBySeason?season=${season}&showAll=${showAll}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getFarmsForLookup(season) {
        const options = {
            method: 'get',
            url: `/umbraco/api/farm/GetBySeason?season=${season}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getAllFarms() {
        const options = {
            method: 'get',
            url: `/umbraco/api/farm/GetAll`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getFarm(id) {

        const options = {
            method: 'get',
            url: `/umbraco/api/farm/GetById?farmId=${id}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    },
    getFarmByName(farmName) {

        const options = {
            method: 'get',
            url: `/umbraco/api/farm/Get?farmName=${farmName}&season=`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        };

        return axios(options)
            .then(response => {
                return response.data;
            })
            .catch(function (error) {
                Sentry.captureException(error);
            });
    }
}